import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
	callAddVehicleBrand, callEditVehicleBrand, callGetVehicleBrand, callGetVehicleBrandById, callDeleteVehicleBrand,
	callAddPolicy, callEditEditPolicy, callGetPolicyById, callGetPolicy, callDeletePolicy, callGetPolicyTypeAll,
	callAddUserManagement, callEditUserManagement, callGetUserManagement, callGetUserManagementById, callDeleteUserManagement,
	callGetAllProvince, callGetDistrict, callGetRoles, callCmsChangePassword,
	callGetSpecialAgentCommision, callGetSpecialAgentCommisionById, callAddSpecialAgentCommision, callEditSpecialAgentCommision, callDeleteSpecialAgentCommision,
	callApproveRejectedSpecialAgentCommision, callSearchUserByKey, callGetMainMenu, callGetSubMenu, callGrandPermission,
	callGetGrandUserPerssion, callDeleteGrandUserPerssion, callGetGrandUserPerssionById,
	callGetAppControls, callGetAppControlsById, callAddAppControls, callEditAppControls, callDeleteAppControls,
	callGetDiscounts, callAddDiscounts, callEditDiscounts, callDeleteDiscounts, callGetDiscountsById
} from "../api/settings/service";

const settingSlice = createSlice({
	name: 'settingData',
	initialState: {
		data: null,
		isLoading: true,
		error: null,
	},
	reducers: {
		setData: (state, { payload }) => {
			state.data = payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(callAddVehicleBrand.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callAddVehicleBrand.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callAddVehicleBrand.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, {
					position: "top-left"
				})
			})
			.addCase(callEditVehicleBrand.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callEditVehicleBrand.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callEditVehicleBrand.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, {
					position: "top-left"
				})
			})
			.addCase(callGetVehicleBrand.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetVehicleBrand.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callGetVehicleBrand.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, {
					position: "top-left"
				})
			})
			.addCase(callGetVehicleBrandById.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetVehicleBrandById.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callGetVehicleBrandById.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, {
					position: "top-left"
				})
			})
			.addCase(callDeleteVehicleBrand.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callDeleteVehicleBrand.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				}
			})
			.addCase(callDeleteVehicleBrand.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, {
					position: "top-left"
				})
			})
		// 🧾 Add/Edit Policy
		builder
			.addCase(callAddPolicy.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callAddPolicy.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callAddPolicy.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})

			.addCase(callEditEditPolicy.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callEditEditPolicy.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callEditEditPolicy.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})

			// 🧾 Get Policy / Get by ID
			.addCase(callGetPolicy.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetPolicy.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callGetPolicy.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})

			.addCase(callGetPolicyById.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetPolicyById.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callGetPolicyById.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})

			// 🗑️ Delete Policy
			.addCase(callDeletePolicy.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callDeletePolicy.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callDeletePolicy.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})

			// 📋 Get All Policy Type
			.addCase(callGetPolicyTypeAll.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetPolicyTypeAll.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callGetPolicyTypeAll.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callAddUserManagement.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callAddUserManagement.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callAddUserManagement.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callEditUserManagement.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callEditUserManagement.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callEditUserManagement.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetUserManagement.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetUserManagement.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callGetUserManagement.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetUserManagementById.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetUserManagementById.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callGetUserManagementById.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callDeleteUserManagement.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callDeleteUserManagement.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callDeleteUserManagement.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetAllProvince.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetAllProvince.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetAllProvince.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetDistrict.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetDistrict.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetDistrict.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetRoles.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetRoles.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetRoles.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callCmsChangePassword.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callCmsChangePassword.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callCmsChangePassword.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetSpecialAgentCommision.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetSpecialAgentCommision.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetSpecialAgentCommision.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetSpecialAgentCommisionById.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetSpecialAgentCommisionById.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetSpecialAgentCommisionById.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callAddSpecialAgentCommision.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callAddSpecialAgentCommision.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callAddSpecialAgentCommision.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callEditSpecialAgentCommision.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callEditSpecialAgentCommision.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callEditSpecialAgentCommision.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callDeleteSpecialAgentCommision.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callDeleteSpecialAgentCommision.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callDeleteSpecialAgentCommision.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callApproveRejectedSpecialAgentCommision.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callApproveRejectedSpecialAgentCommision.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callApproveRejectedSpecialAgentCommision.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callSearchUserByKey.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callSearchUserByKey.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callSearchUserByKey.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetMainMenu.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetMainMenu.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetMainMenu.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetSubMenu.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetSubMenu.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetSubMenu.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGrandPermission.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGrandPermission.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGrandPermission.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetGrandUserPerssion.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetGrandUserPerssion.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetGrandUserPerssion.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callDeleteGrandUserPerssion.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callDeleteGrandUserPerssion.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callDeleteGrandUserPerssion.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetGrandUserPerssionById.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetGrandUserPerssionById.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetGrandUserPerssionById.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callAddAppControls.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callAddAppControls.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callAddAppControls.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callEditAppControls.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callEditAppControls.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callEditAppControls.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetAppControls.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetAppControls.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetAppControls.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callDeleteAppControls.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callDeleteAppControls.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callDeleteAppControls.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetAppControlsById.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetAppControlsById.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetAppControlsById.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetDiscounts.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetDiscounts.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetDiscounts.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callAddDiscounts.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callAddDiscounts.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callAddDiscounts.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callEditDiscounts.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callEditDiscounts.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callEditDiscounts.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callDeleteDiscounts.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callDeleteDiscounts.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callDeleteDiscounts.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetDiscountsById.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetDiscountsById.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetDiscountsById.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
	},
});
export const { setData } = settingSlice.actions;
export default settingSlice.reducer;
